/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './ActionTypes';

const initialState = {
  searchResult: [],
  rebateProgram: '',
  rebateProgramList: [],
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  rebateProgramValue: '',
  rebateProgramNameValue: '',
  errors: [],
  fromDateValue: '',
  toDateValue: '',
  displayObj: {
    searchResult: [],
    rebateProgram: '',
    rebateProgramList: [],
    selectedPlanType: '',
    planType: [],
    rebateProgramValue: '',
    rebateProgramNameValue: '',
    fromDateValue: '',
    toDateValue: '',
    rebateProgrameName: '',
  },
};

const reducer = (state = initialState, Actions) => {
  switch (Actions.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: Actions.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_UNALLOACTED_BALANCE:
    //   return { ...state, rebateProgramList: Actions.payload };

    case ActionTypes.SET_SELECTED_INPUT:
      return { ...state, ...Actions.payload };
    case ActionTypes.REFRESH_FAMILY_PLANNING_DRUG_PMT_REC:
      return {
        ...state,
        rebateProgram: '',
        selectedPlanType: '',
        fromDateValue: '',
        toDateValue: '',
      };
    case ActionTypes.REFRESH_FAMILY_PLANNING_DRUG_PMT_REC_DISPLAY:
      return {
        ...state,
        rebateProgram: '',
        selectedPlanType: '',
        fromDateValue: '',
        toDateValue: '',
      };

    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: Actions.isLoading };
    case ActionTypes.SET_FAMILY_PLANNING_DRUG_PMT_REC_DATA:
      let displayObj = {
        ...state.displayObj,
        searchResult: Actions.payload,
      };
      return { ...state, searchResult: Actions.payload, displayObj };

    default:
      return state;
  }
};

export default reducer;
